import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';
import LinkBox from '../components/LinkBox';

export type PICustomsProps = {};

const PICustoms: React.FC<PICustomsProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/electronics-rs.jpg'}
        heading={
          intl.formatMessage({
            id: 'public_info_8'
          })
        }
      />
      <div className="content">
        <div className="w-full flex flex-row flex-wrap justify-center">
          <div className="w-1/2 p-2">
            <LinkBox target='_blank' href="/pdf/customs/MCB-DOS-070 Solicitud de Carta de Aduana.docx" label={
              intl.formatMessage({
                id: 'customs-letter-req'
              })
            } />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PICustoms;